import React, {
  useCallback, useMemo, useState, ReactElement,
} from 'react';
import Card from '../../../components/card/card.component';
import Button from '../../../components/button/button.component';
import ModalButtonBlock from '../../../components/modal-button-block/modal-button-block.component';
import ModalLabel from '../../../components/modal-label/modal-label.component';
import ModalLayout from '../../../components/modal-layout/modal-layout.component';
import ModalFieldBlock from '../../../components/modal-field-block/modal-field-block.component';
import ModalDescription from '../../../components/modal-description/modal-description.component';
import ErrorBlock from '../../../components/error-block/error-block.component';
import FieldSelect from '../../../components/field-select/field-select.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';
import { FILTER_VALUE_EMPTY } from '../../../constants/system/filter-values';

const DealTaskTemplateLoadModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    dealTaskTemplateList,
    onConfirm,
    errorMessage,
    onCloseModal,
  } = props;

  const [dealTemplateIdValue, setDealTemplateIdValue]: [number, Function] = useState<StateValueDefault>('');

  const isSaveDisabled: boolean = !dealTemplateIdValue && dealTemplateIdValue !== FILTER_VALUE_EMPTY;

  const menuItemDealTaskTemplateList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionList: dealTaskTemplateList,
  }), [dealTaskTemplateList]);

  const closeModal: Function = useCallback((): void => {
    if (onCloseModal) {
      onCloseModal();
    }

    setDealTemplateIdValue('');
  }, []);

  const onDealTemplateChange: Function = useCallback((contactId: number): void => {
    setDealTemplateIdValue(contactId);
  }, []);

  const confirm: MouseEventHandlerFunction = useCallback((): void => {
    if (!dealTemplateIdValue && dealTemplateIdValue !== FILTER_VALUE_EMPTY) {
      return;
    }

    if (onConfirm) {
      onConfirm(dealTemplateIdValue, (): void => {
        setDealTemplateIdValue('');
      });
    }
  }, [dealTemplateIdValue]);

  return (
    <ModalLayout isOpen={isOpen} title="Load Due Diligence Template" onCloseModal={closeModal}>
      <Card isContainer>
        <ModalDescription>
          This action with apply Due Diligence structure from selected template
          and create its groups and tasks in current deal.
        </ModalDescription>
        <ModalLabel>
          Select template:
        </ModalLabel>
        <ModalFieldBlock>
          <FieldSelect
            isPlain
            isBordered
            isDisabled={dealTaskTemplateList && !dealTaskTemplateList.length}
            value={dealTemplateIdValue}
            onChange={(event: EventSelectChange, value: string): void => {
              onDealTemplateChange(value);
            }}
          >
            {menuItemDealTaskTemplateList}
          </FieldSelect>
        </ModalFieldBlock>
      </Card>
      <ModalButtonBlock>
        <Button isActive isDisabled={isSaveDisabled} onClick={confirm}>
          Apply
        </Button>
      </ModalButtonBlock>
      {
        !!errorMessage && (
          <ErrorBlock errorMessage={errorMessage} />
        )
      }
    </ModalLayout>
  );
});

export default DealTaskTemplateLoadModal;
